import { render, staticRenderFns } from "./exhibitionDetail.vue?vue&type=template&id=133aa364&scoped=true"
import script from "./exhibitionDetail.vue?vue&type=script&lang=js"
export * from "./exhibitionDetail.vue?vue&type=script&lang=js"
import style0 from "./exhibitionDetail.vue?vue&type=style&index=0&id=133aa364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133aa364",
  null
  
)

export default component.exports